import React from "react";
import { useSelector } from "react-redux";
import { selectDineInPhase } from "../../../../dataManagement/uiDb/DineInDb";
import DineInBrandHeader from "./DineInBrandHeader";
import DineInCodeReveal from "./DineInCodeReveal";
import DineInCodeEntry from "./DineInCodeEntry";
import DineInSplashTransition from "./DineInSplashTransition";
import "./styles/DineInInitialScreen.css";

interface DineInInitialScreenProps {
  businessId: string;
  tableNumber: string;
  businessName: string;
  /** Business.logoUrl — undefined falls back to a monogram, handled by
   *  DineInSplashTransition itself. Keeps this screen business-agnostic. */
  businessLogoUrl?: string;
}

/** Switches between the two pre-session screens: reveal the code (session
 *  just created) or ask for it (session already existed). Wrapped in a
 *  branded splash transition — see DineInSplashTransition's doc comment —
 *  since by the time this mounts the data is already in hand, so the splash
 *  is a deliberate branded beat rather than a loading gate. */
const DineInInitialScreen: React.FC<DineInInitialScreenProps> = ({
  businessId,
  tableNumber,
  businessName,
  businessLogoUrl,
}) => {
  const phase = useSelector(selectDineInPhase);

  return (
    <DineInSplashTransition brandName={businessName} logoUrl={businessLogoUrl}>
      <div className="dine-in-initial">
        <div data-row>
          <DineInBrandHeader
            businessName={businessName}
            tableNumber={tableNumber}
            live={phase === "revealCode"}
          />
        </div>
        <div data-row>
          {phase === "revealCode" ? (
            <DineInCodeReveal businessName={businessName} />
          ) : (
            <DineInCodeEntry businessId={businessId} tableNumber={tableNumber} />
          )}
        </div>
      </div>
    </DineInSplashTransition>
  );
};

export default DineInInitialScreen;
